<!-- 生成库存盘点计划 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}" @tabHeight="(val)=>{mxHeight=val}">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="100px" :show-message="false" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow==1"
                                                :rules="formOneValue.isRequired == 1 ? [{required: true,  trigger: ['blur', 'change']}] : []">
                                                <!-- 系统字段 -->
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <!-- 库房 -->
                                                <el-tooltip v-if="formOneValue.entityField == 'stId'" class="item" :disabled="sendDataInfo.stName==null||sendDataInfo.stName==''?true:false || sendDataInfo.stName.length<=9" effect="dark"
                                                    :content="sendDataInfo.stName" placement="bottom-start">
                                                    <el-input class="form_codition" clearable v-if="formOneValue.entityField == 'stId'" @keyup.enter.native="openSearch(formOneValue.searchId, 0, 'stId')" v-model="sendDataInfo.stName"
                                                        :maxlength="$store.state.inputLength">
                                                        <el-button @click="openSearch(formOneValue.searchId, 0, 'stId')" slot="append" icon="el-icon-search"></el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <!-- 货主 -->
                                                <el-tooltip v-else-if="formOneValue.entityField == 'coId'" class="item" :disabled="sendDataInfo.coName==null||sendDataInfo.coName==''?true:false || sendDataInfo.coName.length<=9" effect="dark"
                                                    :content="sendDataInfo.coName" placement="bottom-start">
                                                    <el-input class="form_codition" clearable @keyup.enter.native="openSearch(formOneValue.searchId, 0, 'coId')" v-model="sendDataInfo.coName" :maxlength="$store.state.inputLength">
                                                        <el-button @click="openSearch(formOneValue.searchId, 0, 'coId')" slot="append" icon="el-icon-search"></el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                    :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo.coName.length<=9" effect="dark"
                                                    :content="sendDataInfo.coName" placement="bottom-start">
                                                    <el-input class="form_codition" clearable @keyup.enter.native="openSearch(formOneValue.searchId, 0, formOneValue.entityField,formOneValue.setField)"
                                                        v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength">
                                                        <el-button @click="openSearch(formOneValue.searchId, 0, formOneValue.entityField,formOneValue.setField)" slot="append" icon="el-icon-search"></el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <!-- 开始时间 -->
                                                <df-date class="form_codition" :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" v-else-if="formOneValue.fieldType == 'date'" :isShowLong="false"
                                                    v-model="sendDataInfo[formOneValue.entityField]"></df-date>

                                                <el-select size="mini" v-else-if="formOneValue.fieldType == 'formatter' && formOneValue.isShow" @change="(val) => {handleChange(val, formOneValue.fieldEntity)}"
                                                    v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value">
                                                    </el-option>
                                                </el-select>
                                                <!-- 扩展字段 -->
                                                <el-input class="form_codition" v-else-if="formOneValue.entityField == 'ipmRemark'" type="textarea" v-model="sendDataInfo[formOneValue.entityField]"
                                                    :maxlength="$store.state.inputLength"></el-input>
                                                <div v-else-if="formOneValue.entityField == 'shelfIds'">
                                                    <el-button type="primary" @click="openShelfDialog">选择货架</el-button>
                                                    <el-input class="form_codition" type="textarea" v-model="shelfNames"></el-input>
                                                </div>
                                                <el-input class="form_codition" v-else v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                            </el-form-item>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                                        {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                    </span>
                                                </span>
                                                <el-select size="mini" disabled v-else-if="formOneValue.fieldType == 'formatter' && formOneValue.isShow" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                    <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value">
                                                    </el-option>
                                                </el-select>
                                                <span v-else-if="formOneValue.fieldType == 'formatter'">
                                                    {{ $common.getIsGsp(formOneValue.formatterContent, sendDataInfo[formOneValue.entityField]) }}
                                                </span>
                                                <span v-else-if="formOneValue.entityField == 'shelfIds'">{{ sendDataInfo.shelfCodes }}</span>
                                                <span v-else-if="formOneValue.entityField == 'stId'">{{ sendDataInfo['stName'] }}</span>
                                                <span v-else-if="formOneValue.entityField == 'coId'">{{ sendDataInfo['coName'] }}</span>
                                                <span v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{ sendDataInfo[formOneValue.entityField]== 1 ? "是" : "否" }}</span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                    <!-- 明细信息 -->
                                    <el-table class="baseTable" v-if="mxForm && dataActionBox.actionType == 2" ref="mxTableRef" :data="sendDataInfo.invplanDetailInfos" border size="mini" :height="mxHeight">
                                        <el-table-column align="center" :prop="formOneValue.entityField" :label="formOneValue.showField" v-for="(formOneValue,formOneKey) in mxForm.jurconfigform" :key="formOneKey"
                                            :min-width="formOneValue.fieldWeight" v-if="formOneValue.isShow==1" show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <!-- 生产日期 -->
                                                <span v-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="scope.row[formOneValue.entityField]">
                                                        {{$common.getLocalTime(scope.row[formOneValue.entityField])}}
                                                    </span>
                                                </span>
                                                <span v-else-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(scope.row[formOneValue.riftField])">{{scope.row[formOneValue.entityField]}}</a>
                                                </span>
                                                <span v-else>
                                                    {{scope.row[formOneValue.entityField]}}
                                                </span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div :class="[dataActionBox.actionType == 2?'foot':'foots']">
                    <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印
                    </el-button>
                    <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType!=2">取消</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==0">保存</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType==1">保存</el-button>
                </div>
            </div>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 范围穿梭框 -->
        <el-dialog :title="'选择货架'" :visible.sync="shelfDialogVisible" width="70%" :modal-append-to-body='true' id="csDia" :append-to-body="true">
            <div class="edit_dev">
                <el-transfer filterable v-if="shelfDialogVisible" target-order="push" :filter-method="filterMethod" filter-placeholder="请输入货架" v-model="sendDataInfo.shelfIds" :titles="['未选择', '已选择']" :data="transferData">
                </el-transfer>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="shelfDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmShelf">确 定</el-button>
            </span>
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import NP from "number-precision";
export default {
    name: "createStockLnventoryPlan",
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
    },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            selectDataTable: false,
            sendDataInfo: {
                movmReserves1: "",
                movmReserves2: "",
                movmReserves3: "",
                movmReserves4: "",
                movmReserves5: "",
                movmReserves6: "",
                movmId: "",
                stId: "",
                stName: "",
                coId: "",
                coName: "",
                rangeType: 1,
            },
            selectedDataIndex: 0,
            storageRoomList: [],
            selectedDetails: [],
            selectGoodsInfo: "",
            showTabs: "",
            formDataList: [],
            DialogVisible: false,
            setField: "",
            seTitle: "",
            seWidth: "",
            exWidth: "",
            parentSearchData: {
                movmOutstid: "",
            },
            mxHeight: 0,
            tabForm: [], // tab循环的主表单
            mxForm: [],
            footForm: [],
            shelfList: [],
            shelfNames: "",
            transferData: [],
            shelfDialogVisible: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.coName"() {
            if (this.sendDataInfo.coName == "") {
                this.sendDataInfo.coId = ""
            }
        },
        "sendDataInfo.stName"() {
            if (this.sendDataInfo.stName == "") {
                this.sendDataInfo.stId = ""
            }
        }
    },
    //方法集合
    methods: {
        // 过滤方法
        filterMethod(query, item) {
            console.log(item);
            if (query != '') {
                if (/^[a-zA-Z]*$/.test(query)) {
                    // alert("“" + str + "”里全是字母！");
                    return item.pinyin.indexOf(query) > -1;
                }
                else if (/^[\u4e00-\u9fa5]*$/.test(query)) {
                    // alert("“" + str + "”里全是汉字！");
                    return item.label.indexOf(query) > -1;
                }
            }
            return item.pinyin.indexOf(query) > -1;
        },
        openShelfDialog() {
            if (!this.sendDataInfo.shelfIds) {
                this.sendDataInfo.shelfIds = []
            }
            this.transferData = this.shelfList.map(item => {
                return {
                    key: item.shelfId,
                    label: item.shelfCode,
                    pinyin: item.shelfCode,
                }
            });
            this.shelfDialogVisible = true;
        },
        confirmShelf() {
            this.shelfDialogVisible = false;
            const idSet = new Set(this.sendDataInfo.shelfIds.map(String));
            this.shelfNames = this.shelfList.filter(item => idSet.has(String(item.shelfId))).map(item => item.shelfCode).join(',');
        },
        handleChange(value, name) {
            console.log(value, name);
            // value默认参，name当前所需的name
            this.sendDataInfo[name] = value;
        },
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) {
                this.$parent.$parent.toDetail(orderId);
            } else {
                this.$parent.$parent.$parent.toDetail(orderId);
            }
        },
        // 打印方法
        showPrintPlan() {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        changeInputModel(val) {
            console.log(val);
            this.DialogVisible = false;
            console.log(this.seType);
            if (val != "" || val != undefined) {
                if (this.seType == "stId") {
                    this.sendDataInfo.stName = val.stName;
                    this.sendDataInfo.stId = val.stId;
                    this.parentSearchData.movmOutstid = this.sendDataInfo.movmOutstid;
                } else if (this.seType == "coId") {
                    this.sendDataInfo.coName = val.coName;
                    this.sendDataInfo.coId = val.coId;
                } else if (this.seType == "bgmName") {
                    for (let fkey in this.sendDataInfo.movedetailAdds[this.seIndex]) {
                        for (let vkey in val) {
                            if (fkey == vkey) {
                                this.sendDataInfo.movedetailAdds[this.seIndex][fkey] =
                                    val[vkey];
                            }
                        }
                    }
                    this.sendDataInfo.movedetailAdds[this.seIndex].movdOutbgsid =
                        val.bgsId;
                } else {
                    this.paramValue(val)
                }
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.setField.split(",");
            console.log(arr);

            arr.forEach((item) => {
                this.sendDataInfo[item] = val[item];
            });
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, setField) {
            console.log(type, "----7");
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.setField = setField
            this.seType = type;
            if (type == 'stId') {
                this.parentSearchData["stName"] = this.sendDataInfo["stName"];
            } else if (type == 'coId') {
                this.parentSearchData["coName"] = this.sendDataInfo["coName"];
            } else {
                this.parentSearchData[type] = this.sendDataInfo[type];
            }
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        // 获取所有可用库房列表
        // async getAllStorageRoom() {
        //   let responseData = await this.$http.getAllStorageRoom();
        //   if (responseData.status == 200) {
        //     this.storageRoomList = responseData.result;
        //   } else {
        //     this.$message({
        //       message: responseData.message,
        //       type: "error",
        //     });
        //   }
        // },

        initActionBox(sendDataInfo) {
            this.$emit('drawerCancel', 0)
            // this.init();
            this.$refs.sendDataInfo.resetFields();
        },
        // init() {
        //   for (let key in this.sendDataInfo) {
        //     this.sendDataInfo[key] = "";
        //   }
        //   this.sendDataInfo.totalCount = 0; //总条目数
        //   this.sendDataInfo.totalMoney = 0; // 总金额
        //   this.sendDataInfo.totalNumber = 0; // 总数量
        // },
        // async isShowData(name, value) {
        //   this.sendDataInfo[name] = value;
        // },

        openBox() {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = this.actionData.formData
            var oldData = this.actionData.oldData
            this.showTabs = this.actionData.formData[0].jciName
            this.filterMainField()
            if (this.dataActionBox.actionType == 0 || this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
            } else {
                this.dataActionBox.boxTitle = '查看信息'
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
                if (this.sendDataInfo.invMode == 1) {
                    this.sendDataInfo.shelfCodes = dataInfo.shelfCodes
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                }, 16.7)
            });
        },
        // 过滤表单不同类型
        filterMainField() {
            const SHELF_FORM_ID = 18000000804264
            const { cate, oldData } = this.actionData
            const isAddMode = cate == 0 || cate == 1
            const mainFormList = []

            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    // 新增：全部主表；查看：按盘点模式筛选货位表单
                    const include = isAddMode || (oldData.invMode == 1
                        ? item.jciId == SHELF_FORM_ID
                        : item.jciId != SHELF_FORM_ID)
                    if (include) mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })

            mainFormList.forEach((item, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(item))
                this.tabForm[i].jurconfigform = item.jurconfigform.filter(f => f.isShow == 1)
            })

            const obj = this.$common.filterMainFields(this.formDataList, [], mainFormList[0])
            for (const key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
        },
        // 新增或者编辑
        sendDataAction(sendDataInfo) {
            console.log(sendDataInfo);
            this.$refs.sendDataInfo.validate((valid) => {
                if (valid) {
                    this.sub();
                } else {
                    return false;
                }
            });
        },
        async sub() {
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
            if (this.actionData.cate == 1) {
                sendData.invMode = 1
                if (this.shelfNames) {
                    sendData.shelfCodes = this.shelfNames
                } else {
                    sendData.shelfCodes = ""
                }
            } else {
                sendData.invMode = 0
            }
            var responseData = await this.$http.createStockLnventoryPlan(sendData);
            if (responseData.status == 200) {
                this.$emit('drawerCancel', 1)
                // this.init();
                this.$message.success("操作成功");
            } else {
                this.$message.error(responseData.message);
            }
        },
        deleteDetails(index) {
            if (this.sendDataInfo.movedetailAdds.length > 0) {
                this.sendDataInfo.movedetailAdds.splice(this.selectedDataIndex, 1);
                this.selectedDataIndex = 0;
            } else {
                return this.$message({
                    message: "暂无可删除明细",
                    type: "warning",
                });
            }
        },
        async storeShelfGetShelfList() {
            let storeId = ""
            if (sessionStorage.getItem('shopInfo')) {
                storeId = JSON.parse(sessionStorage.getItem('shopInfo')).storeId
            }
            let responseData = await this.$http.storeShelfGetShelfList({
                page: 1,
                rows: 9999,
                storeId: storeId
            });
            if (responseData.status == 200) {
                this.shelfList = responseData.result.list;
            } else {
                this.$message.error(responseData.message);
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.storeShelfGetShelfList()
        this.$nextTick(() => {
            this.openBox()
        })
        // this.getAllStorageRoom();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
    margin-bottom: 0;
}
</style>